import { render } from "./HowItWork.vue?vue&type=template&id=b24b16d6"
import script from "./HowItWork.vue?vue&type=script&lang=js"
export * from "./HowItWork.vue?vue&type=script&lang=js"

import "./HowItWork.vue?vue&type=style&index=0&id=b24b16d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__